import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {Alert, Drawer} from 'antd';

import PreviewCommentList from '@/page/app/CommentPage/PreviewCommentList';

const ExtraNewsCommentDrawer = forwardRef((props, ref) => {
    const [visible, setVisible] = useState(false);
    const [newsItemId, setNewsItemId] = useState(null);
    console.log('newsItemId', newsItemId);

    function show(newsItemId) {
        setVisible(true);
        setNewsItemId(newsItemId);
    }

    function hide() {
        setVisible(false);
    }

    useImperativeHandle(ref, () => ({
        show,
        hide,
    }));

    function afterVisibleChange(vis) {}

    return (
        <Drawer
            visible={visible}
            width={600}
            onClose={hide}
            destroyOnClose
            afterVisibleChange={afterVisibleChange}
        >
            <Alert
                showIcon
                type="warning"
                banner
                description="展示留言方会显示在图文页面"
                message="提醒"
            />
            {newsItemId && <PreviewCommentList itemId={newsItemId} />}
        </Drawer>
    );
});

ExtraNewsCommentDrawer.displayName = 'ExtraNewsCommentDrawer';

ExtraNewsCommentDrawer.propTypes = {};

export default ExtraNewsCommentDrawer;
